import consola from 'consola';
import type { PiniaPluginContext } from 'pinia';

const storeRegistry: PiniaPluginContext['store'][] = [];

export function storeTrackerPlugin({ store }: PiniaPluginContext) {
    storeRegistry.push(store);
}

export function resetAllStores() {
    storeRegistry.forEach((store) => {
        if (store.$id === 'server') {
            return;
        }
        if (typeof store.reset === 'function') {
            store.reset();
        } else if (typeof store.$reset === 'function') {
            store.$reset();
        } else {
            consola.warn(`[pinia] Store "${store.$id}" has no $reset() or reset()`);
        }
    });
}
